import { createSlice } from "@reduxjs/toolkit";

// Phases: "downloading" | "installing" | "rebooting" | "complete" | null
const firmwareUpdateSlice = createSlice({
  name: "firmwareUpdate",
  initialState: {
    // { [serialNumber]: { phase, startedAt, initialFirmware } }
    devices: {},
  },
  reducers: {
    startUpdate(state, action) {
      const { sn, firmware } = action.payload;
      state.devices[sn] = {
        phase: "downloading",
        startedAt: Date.now(),
        initialFirmware: firmware,
      };
    },
    setUpdatePhase(state, action) {
      const { sn, phase } = action.payload;
      if (state.devices[sn]) {
        state.devices[sn].phase = phase;
      }
    },
    clearUpdate(state, action) {
      const sn = action.payload;
      delete state.devices[sn];
    },
  },
});

export const { startUpdate, setUpdatePhase, clearUpdate } =
  firmwareUpdateSlice.actions;

export const selectUpdatePhase = (sn) => (state) =>
  state.firmwareUpdate.devices[sn]?.phase || null;

export const selectInitialFirmware = (sn) => (state) =>
  state.firmwareUpdate.devices[sn]?.initialFirmware || null;

export default firmwareUpdateSlice.reducer;
